export default __webpack_public_path__ + "static/top_company_img-1528e0d6925ee2c2efd1492f7ef0613a.jpg";